export type OnlineOrderTuneId =
  | 'tune-1'
  | 'tune-2'
  | 'tune-3'
  | 'tune-4'
  | 'tune-5'
  | 'tune-6'
  | 'tune-7'
  | 'tune-8'
  | 'tune-9'
  | 'tune-10'
  | 'tune-11'
  | 'tune-12'
  | 'tune-13'
  | 'tune-14'
  | 'tune-15';

export interface OnlineOrderAlertSettings {
  tuneId: OnlineOrderTuneId;
  volume: number;
}

export const ONLINE_ORDER_ALERT_STORAGE_KEY = 'pos_online_order_alert_settings';

export const DEFAULT_ONLINE_ORDER_ALERT_SETTINGS: OnlineOrderAlertSettings = {
  tuneId: 'tune-1',
  volume: 0.6,
};

export const ONLINE_ORDER_TUNES: Array<{ id: OnlineOrderTuneId; label: string }> = [
  { id: 'tune-1', label: 'Classic Beep' },
  { id: 'tune-2', label: 'Soft Beep' },
  { id: 'tune-3', label: 'Low Beep' },
  { id: 'tune-4', label: 'Double Beep' },
  { id: 'tune-5', label: 'Sharp Beep' },
  { id: 'tune-6', label: 'Warm Beep' },
  { id: 'tune-7', label: 'High Ping' },
  { id: 'tune-8', label: 'Mid Ping' },
  { id: 'tune-9', label: 'Bright Ping' },
  { id: 'tune-10', label: 'Quick Double' },
  { id: 'tune-11', label: 'Rising Alert' },
  { id: 'tune-12', label: 'Steady Pulse' },
  { id: 'tune-13', label: 'Two-Tone Alert' },
  { id: 'tune-14', label: 'Quadruple Knock' },
  { id: 'tune-15', label: 'Order Fanfare' },
];

export function isOnlineOrderTuneId(value: unknown): value is OnlineOrderTuneId {
  return typeof value === 'string' && ONLINE_ORDER_TUNES.some((tune) => tune.id === value);
}

let cachedSettings: OnlineOrderAlertSettings | null = null;

function parseStoredSettings(raw: string | null): OnlineOrderAlertSettings {
  if (!raw) return { ...DEFAULT_ONLINE_ORDER_ALERT_SETTINGS };
  try {
    const parsed = JSON.parse(raw) as Partial<OnlineOrderAlertSettings>;
    const volume = Number(parsed.volume);
    return {
      tuneId: isOnlineOrderTuneId(parsed.tuneId)
        ? parsed.tuneId
        : DEFAULT_ONLINE_ORDER_ALERT_SETTINGS.tuneId,
      volume: Number.isFinite(volume)
        ? Math.min(1, Math.max(0, volume))
        : DEFAULT_ONLINE_ORDER_ALERT_SETTINGS.volume,
    };
  } catch {
    return { ...DEFAULT_ONLINE_ORDER_ALERT_SETTINGS };
  }
}

export function readOnlineOrderAlertSettings(): OnlineOrderAlertSettings {
  if (cachedSettings) return cachedSettings;
  try {
    cachedSettings = parseStoredSettings(localStorage.getItem(ONLINE_ORDER_ALERT_STORAGE_KEY));
  } catch {
    cachedSettings = { ...DEFAULT_ONLINE_ORDER_ALERT_SETTINGS };
  }
  return cachedSettings;
}

export function writeOnlineOrderAlertSettings(settings: OnlineOrderAlertSettings): void {
  cachedSettings = settings;
  try {
    localStorage.setItem(ONLINE_ORDER_ALERT_STORAGE_KEY, JSON.stringify(settings));
  } catch {
    /* ignore quota errors */
  }
}
